export default __webpack_public_path__ + "assets/schick_banner_350x160-123aceee7d5e30b91bbe21db526c306f.jpg";